var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { KnownContext, } from '@spotify-internal/remote-config-core';
export function sessionConfig(next) {
    return () => {
        let config = null;
        let configHash = '';
        return (req) => __awaiter(this, void 0, void 0, function* () {
            const hash = KnownContext.hash(req);
            if (configHash === hash) {
                return config;
            }
            config = yield next(req);
            configHash = hash;
            return config;
        });
    };
}
//# sourceMappingURL=sessionConfig.js.map